// Małe, wielokrotnie używane elementy UI panelu.
import { hashHue, initials } from "./format";
import {
  PRIORITY_META,
  PRODUCT_META,
  STATUS_META,
  type LeadPriority,
  type LeadStatus
} from "./types";

export function Avatar({ name, size = 40 }: { name: string; size?: number }) {
  const hue = hashHue(name || "?");
  return (
    <span
      className="crm-avatar"
      style={{
        width: size,
        height: size,
        fontSize: Math.round(size * 0.36),
        background: `hsl(${hue} 68% 90%)`,
        color: `hsl(${hue} 52% 30%)`
      }}
      aria-hidden="true"
    >
      {initials(name)}
    </span>
  );
}

export function StatusBadge({ status }: { status: LeadStatus }) {
  const meta = STATUS_META[status];
  return <span className={`crm-badge ${meta.tone}`}>{meta.label}</span>;
}

export function PriorityBadge({ priority, compact = false }: { priority: LeadPriority; compact?: boolean }) {
  const meta = PRIORITY_META[priority];
  if (compact && priority === "normal") return null;
  return (
    <span className={`crm-pill ${meta.tone}`} title={`Priorytet: ${meta.label}`}>
      {priority === "high" ? "⬤" : priority === "low" ? "◯" : "•"} {meta.label}
    </span>
  );
}

export function ProductTag({ product, short = true }: { product: string; short?: boolean }) {
  const meta = PRODUCT_META[product];
  const label = meta ? (short ? meta.short : meta.label) : product || "—";
  return <span className="crm-product-tag">{label}</span>;
}

export function OwnerChip({ owner }: { owner: string }) {
  if (!owner) return <span className="crm-owner crm-owner--none">Nieprzypisany</span>;
  return (
    <span className="crm-owner">
      <Avatar name={owner} size={22} />
      {owner}
    </span>
  );
}
